export default "__VITE_ASSET__15ee4994__"